import Admin from './Admin/route.js'
import CRM from './CRM/route.js'
import Dev from './Dev/route.js'

export default [...Admin, ...CRM, ...Dev,]